module.exports = "<div class=\"terms-container\" (click)=\"closeTermsPopup()\">\n    <div class=\"terms-content\" (click)=\"stopProp($event)\">\n      <i class=\"material-icons\" (click)=\"closeTermsPopup()\">close</i>\n      <div class=\"terms-header\">\n        Terms & Conditions\n      </div>\n      <perfect-scrollbar class=\"terms-field\">\n        <div [innerHTML]=\"termsAndConditionString\"></div>\n      </perfect-scrollbar>\n    </div>\n  </div>\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/terms-condition/terms-condition/terms-condition.component.html
// module id = ./src/app/modules/terms-condition/terms-condition/terms-condition.component.html
// module chunks = main